import styled, { keyframes } from 'styled-components'

const addIn = keyframes`
  from {
    scale: 0;
    height: 0;
  }
  to {
    height: 60px;
    scale: 1;
  }
`

export const ErrorsWrapper = styled.div`
  display: flex;
  flex-direction: column;
`

export const Error = styled.div`
  padding-left: 24px;
  padding-right: 24px;
  height: 60px;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;
  border-top: 1px solid var(--theme-colors-global-grey-grey300);

  &:first-child {
    border: none;
  }

  &:hover {
    cursor: pointer;
    background: var(--theme-colors-global-grey-grey100);
  }

  transform-origin: top left;
  scale: 1;
  transition:
    scale 0.25s ease-out,
    height 0.25s ease-out,
    background-color 0.25s;

  &.removing {
    scale: 0;
    height: 0;
    border-top: 0;
  }

  animation: ${addIn} 250ms ease-in;
`

export const ErrorMessageWrapper = styled.div`
  min-width: 0;
`

export const ErrorFieldName = styled.div`
  font: var(--theme-typography-bodyM-semiBold);
  color: var(--theme-colors-global-grey-grey700);
  text-wrap: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const ErrorMessage = styled.div`
  font: var(--theme-typography-bodyL-regular);
  color: var(--theme-colors-global-general-secondary);
  text-wrap: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`
